var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 57,
    viewBox: "0 0 52 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4993 19.5329C48.113 20.4386 49.4567 21.7594 50.392 23.3591C51.3273 24.9589 51.8204 26.7797 51.8204 28.6341C51.8204 30.4885 51.3273 32.3094 50.392 33.9091C49.4567 35.5088 48.113 36.8296 46.4993 37.7353L15.6135 55.0475C14.0288 55.9342 12.2404 56.3903 10.4257 56.3705C8.61105 56.3508 6.83301 55.8559 5.26781 54.9349C3.70262 54.0138 2.4046 52.6987 1.5024 51.1197C0.600199 49.5407 0.125128 47.7528 0.124269 45.933V11.3219C0.123499 9.50176 0.597779 7.71308 1.49997 6.13364C2.40217 4.55421 3.70086 3.23903 5.26698 2.3188C6.8331 1.39858 8.61212 0.905361 10.4272 0.888161C12.2423 0.870961 14.0303 1.33038 15.6135 2.22076L46.4993 19.5329Z",
    fill: "#FFFBF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.2955769ec5bd1324b162726c026707bc.svg";
export { ForwardRef as ReactComponent };